var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.438,
    height: 15.438,
    viewBox: "0 0 15.438 15.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185557",
    "data-name": "Group 185557",
    transform: "translate(357.488 -578.169) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54900",
    "data-name": "Path 54900",
    d: "M161.1,664l5.857-5.857L172.818,664",
    fill: "none",
    stroke: "#4169e1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54901",
    "data-name": "Path 54901",
    d: "M166.961,658.143v13.634",
    fill: "none",
    stroke: "#4169e1",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirectIcon.5a376c28fdc130c3d33637564de7eba2.svg";
export { ForwardRef as ReactComponent };